import PrintScout from 'printscout';
const SCOUT = new PrintScout(),
	$main = $('.main');

SCOUT.on('beforeprint', () => { 
	let title = $('html').find('title').html();
	// if (!$('.news--detail').length) {
		$main.prepend(`<div class="layout__row"><h1 class="print-title" style="display: none;">${title}</h1></div>`);
	// }
});

SCOUT.on('afterprint', () => {
	// if (!$('.news--detail').length) {
		$(document)
			.find('.print-title')
			.parent()
			.remove();
	// }
});


// WEBPACK FOOTER //
// ./frontend/components/print/print.js